export const styles = {
  header: {
    flexDirection: 'row',
    paddingLeft: '8px',
    paddingRight: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerWrap: {
    backgroundColor: '#FFFFFF',
    paddingTop: '8px',
  },
}
